// color-exempt-file — retokenisation Phase 6 ui-themes : dark:bg-[#030712] preserve le rendu dark historique (voir memoire ui-themes)
import React from "react";
import { useTranslation } from "react-i18next";
import { DataControlUI } from "@core/components/DataControlUI";
import { useDataControl } from "@core/hooks/useDataControl";
import { AuthRequired } from "@core/components/AuthRequired";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { SEOHead } from "../components/SEOHead";

export default function DataControl() {
  const { t } = useTranslation("common");
  const dataControl = useDataControl("date");

  return (
    <>
      <SEOHead title={t("seo_title_data_control")} noIndex />
      <AuthRequired
        header={<ProductHeader productType="date" showAuth={true} />}
      >
        <div className="min-h-screen-safe bg-background dark:bg-[#030712]">
          {/* Barre haute avec connexion */}
          <ProductHeader productType="date" showAuth={true} />

          {/* Contenu principal avec sidebar */}
          <div className="flex">
            {/* Sidebar auto-suffisante avec son hamburger */}
            <ProductSidebar productType="date" />

            {/* Contenu principal */}
            <div className="flex-1">
              <DataControlUI productType="date" {...dataControl} />
            </div>
          </div>
        </div>
      </AuthRequired>
    </>
  );
}
